import React from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import useActivityTracker from '../../hooks/useActivityTracker';
import Guia from '../../components/guia/guia'; 

const GuiaPage = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    useActivityTracker(user?.username, 'guide');

    return (
        <main>
            <Guia />
        </main>
    );
};

export default GuiaPage;